import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  getNewIDData: {},
  error: "",
  success: false,
  status: "",
};

const getNewIDCall = createAsyncThunk("post/getnewID", async (data) => {
  try {
    const result = await axios.post(
      "https://apac-apigateway.capillarytech.com/mobile/v2/api/transactions/reject",
      data
    );
  
    return result?.data;
  } catch (err) {
    console.log(err);
  }
});

const getNewIdSlice = createSlice({
  name: "getnewId",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNewIDCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNewIDCall.fulfilled, (state, action) => {
  
      state.loading = false;
      state.getNewIDData = action.payload;
      // state.success = action.payload?.status.success === "true" ? true : false;
      state.error = "";
    });
    builder.addCase(getNewIDCall.rejected, (state, action) => {
      state.loading = false;
      state.getNewIDData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default getNewIdSlice.reducer;
export const { reset } = getNewIdSlice.actions;
export { getNewIDCall };
